export const messages = {
  en: {
    maintainanceTaskDetails: {
      search: {
        title: 'Search Conditions',
        planUserName: 'Please enter maintainer',
        maintainanceStartTime: 'Please enter actual maintenance start time',
        maintainanceEndTime: 'Please enter actual maintenance end time',
        maintainancePlanId: 'Please select maintenance plan',
        selectPlan: 'Select plan',
        taskDetailId: 'Please enter task detail ID',
        taskState: 'Please select task status',
        selectState: 'Select status'
      },
      list: {
        title: 'Maintenance Details'
      },
      table: {
        taskDetailId: 'ID',
        machineName: 'Equipment Name',
        planName: 'Plan Name',
        standardName: 'Maintenance Standard',
        planUserName: 'Planned Maintainer',
        planTime: 'Maintainer\nStart/End Time',
        inspectionTime: 'Actual Maintenance Time',
        actUserName: 'Actual Maintainer',
        stateName: 'Task Status',
        description: 'Maintenance Situation',
        photos: 'Maintenance Photos',
        createTime: 'Create Time'
      },
      fetchError: 'Failed to fetch maintenance task details',
      noLocation: 'No location information available'
    }
  },
  zh: {
    maintainanceTaskDetails: {
      search: {
        title: '查询条件',
        planUserName: '请输入保养人',
        maintainanceStartTime: '请输入实际保养开始时间',
        maintainanceEndTime: '请输入实际保养结束时间',
        maintainancePlanId: '请选择保养计划',
        selectPlan: '选择计划',
        taskDetailId: '请输入任务详情ID',
        taskState: '请选择任务状态',
        selectState: '选择状态'
      },
      list: {
        title: '保养明细信息'
      },
      table: {
        taskDetailId: '编号',
        machineName: '设备名称',
        planName: '计划名称',
        standardName: '保养标准',
        planUserName: '计划保养人',
        planTime: '保养人\n开始/结束时间',
        inspectionTime: '实际保养时间',
        actUserName: '实际保养人',
        stateName: '任务状态',
        description: '保养情况',
        photos: '保养照片',
        createTime: '创建时间'
      },
fetchError: '获取保养任务详情失败',
      noLocation: '暂无位置信息'
    }
  },
  'zh-TW': {
    maintainanceTaskDetails: {
      search: {
        title: '查詢條件',
        planUserName: '請輸入保養人',
        maintainanceStartTime: '請輸入實際保養開始時間',
        maintainanceEndTime: '請輸入實際保養結束時間',
        maintainancePlanId: '請選擇保養計劃',
        selectPlan: '選擇計劃',
        taskDetailId: '請輸入任務詳情ID',
        taskState: '請選擇任務狀態',
        selectState: '選擇狀態'
      },
      list: {
        title: '保養明細信息'
      },
      table: {
        taskDetailId: '編號',
        machineName: '設備名稱',
        planName: '計劃名稱',
        standardName: '保養標準',
        planUserName: '計劃保養人',
        planTime: '保養人\n開始/結束時間',
        inspectionTime: '實際保養時間',
        actUserName: '實際保養人',
        stateName: '任務狀態',
        description: '保養情況',
        photos: '保養照片',
        createTime: '創建時間'
      },
      fetchError: '獲取保養任務詳情失敗',
      noLocation: '暫無位置信息'
    }
  }
}